import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
  })
export class ErrorMessageService {
  private errorStatus: number;

  setError(status: number) {
    this.errorStatus = status;
  }

  getErrorStatus(): number {
    return this.errorStatus;
  }
}



